import { Injectable } from '@angular/core';
import {  NGXLogger ,NgxLoggerLevel} from 'ngx-logger';

@Injectable()
export class LogService {
    constructor( private logger:NGXLogger){  }

    info(message:any)
    {
        this.logger.info(message);
    }

    trace(message:any)
    {
        this.logger.trace(message);
    }

    log(message:any)
    {
        this.logger.log(message);
    }

    debug(message:any)
    {
        this.logger.debug(message);
    }

    warn(message:any)
    {
        this.logger.warn(message);
    }

    error(message:any)
    {
        this.logger.error(message);
    }

    fatal(message:any)
    {
        this.logger.fatal(message);
    }
 }